import { CSSProperties } from "react";

const PersonIcon = ({
  scale,
  color,
  style,
  className,
}: {
  scale?: number;
  color?: string;
  style?: CSSProperties;
  className?: string;
}) => {
  let c = "#95A3B5";
  if (color) c = color;
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `scale(${scale || 1})`, ...style }}
      className={className}
    >
      <path
        d="M16.8334 9.00005C16.8334 10.5649 15.5649 11.8334 14.0001 11.8334V12.8334C16.1172 12.8334 17.8334 11.1171 17.8334 9.00005H16.8334ZM14.0001 11.8334C12.4353 11.8334 11.1667 10.5649 11.1667 9.00005H10.1667C10.1667 11.1171 11.883 12.8334 14.0001 12.8334V11.8334ZM11.1667 9.00005C11.1667 7.43524 12.4353 6.16672 14.0001 6.16672V5.16672C11.883 5.16672 10.1667 6.88296 10.1667 9.00005H11.1667ZM14.0001 6.16672C15.5649 6.16672 16.8334 7.43524 16.8334 9.00005H17.8334C17.8334 6.88296 16.1172 5.16672 14.0001 5.16672V6.16672ZM11.5001 15.3334H16.5001V14.3334H11.5001V15.3334ZM16.5001 21.0001H11.5001V22H16.5001V21.0001ZM11.5001 21.0001C9.93527 21.0001 8.66675 19.7315 8.66675 18.1667H7.66675C7.66675 20.2838 9.38299 22 11.5001 22V21.0001ZM19.3334 18.1667C19.3334 19.7315 18.0649 21.0001 16.5001 21.0001V22C18.6172 22 20.3334 20.2838 20.3334 18.1667H19.3334ZM16.5001 15.3334C18.0649 15.3334 19.3334 16.6019 19.3334 18.1667H20.3334C20.3334 16.0496 18.6172 14.3334 16.5001 14.3334V15.3334ZM11.5001 14.3334C9.38299 14.3334 7.66675 16.0496 7.66675 18.1667H8.66675C8.66675 16.6019 9.93527 15.3334 11.5001 15.3334V14.3334Z"
        fill={c}
      />
      <rect x="0.5" y="0.500061" width="27" height="27" rx="13.5" stroke="#9DB3D4" />
    </svg>
  );
};

export default PersonIcon;
